import React from 'react'
import { Link } from 'react-router-dom'

interface BlogPostHeaderProps {
  isEditing: boolean
}

const BlogPostHeader: React.FC<BlogPostHeaderProps> = ({ isEditing }) => {
  return (
    <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4'>
      <h2 className='mb-3 mb-md-0'>{isEditing ? 'Edycja artykułu' : 'Dodawanie nowego artykułu'}</h2>
      <Link to='/blog' className='btn btn-outline-secondary'>
        <i className='icon-arrow-left me-2' />Powrót do listy
      </Link>
    </div>
  )
}

export default BlogPostHeader
